export default "__VITE_ASSET__e760d305__"